import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-role-selection',
  templateUrl: './role-selection.component.html',
  styleUrls: ['./role-selection.component.scss'],
})
export class RoleSelectionComponent implements OnInit, OnChanges {
  @Input() roles: any[] = [];
  @Input() currentRoleId: any = null;
  private preparedRoles: any[] | null = null;

  constructor(private modalCtrl: ModalController, private navParams: NavParams) {
    // Ionic assigns componentProps after construction. Read them here so the
    // first paint already has the roles, including right after email login.
    const incoming = this.navParams?.get?.('roles');
    if (Array.isArray(incoming) && incoming.length) {
      this.roles = incoming;
    }
    const currentRoleId = this.navParams?.get?.('currentRoleId');
    if (currentRoleId != null) {
      this.currentRoleId = currentRoleId;
    }
  }

  ngOnChanges() {
    this.prepareRoles();
  }

  ngOnInit() {
    this.prepareRoles();
  }

  private prepareRoles() {
    console.log('[RoleSelection] Incoming roles:', this.roles);
    if (!this.roles?.length || this.preparedRoles === this.roles) {
      return;
    }
    this.preparedRoles = this.roles;
    console.log('[RoleSelection] Before sort:', this.roles);

      this.roles.sort((a, b) => {
        const aIsPrimary = this.isPrimaryRole(a);
        const bIsPrimary = this.isPrimaryRole(b);
        if (aIsPrimary !== bIsPrimary) {
          return aIsPrimary ? -1 : 1;
        }

        if (a.date_created && b.date_created) {
          return new Date(a.date_created).getTime() - new Date(b.date_created).getTime();
        }

        const emailA = a.email || a.description || '';
        const emailB = b.email || b.description || '';

        if (emailA && emailB) {
          return emailA.localeCompare(emailB);
        }

        if (a.id && b.id) {
          return a.id > b.id ? 1 : -1;
        }

        return 0;
      });
  
      const roleOccurrences: { [key: string]: number } = {};
      const roleCounters: { [key: string]: number } = {};
  
      this.roles.forEach(role => {
        const roleName = role.name || 'User';
        roleOccurrences[roleName] = (roleOccurrences[roleName] || 0) + 1;
      });
  
      this.roles.forEach(role => {
        const roleName = role.name || 'User';
        if (roleOccurrences[roleName] > 1) {
          roleCounters[roleName] = (roleCounters[roleName] || 0) + 1;
          role.display_name = `${roleName}${roleCounters[roleName]}`;
        } else {
          role.display_name = roleName;
        }
      });

    console.log('[RoleSelection] ngOnInit - roles assigned:', this.roles);
  }
  isPrimaryRole(role: any): boolean {
    return role?.is_parent === true || role?.is_parent === 'true' || role?.is_parent === 1;
  }

  selectRole(role: any) {
    console.log('[RoleSelection] Selected Role:', role);
    this.modalCtrl.dismiss(role);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  getRoleColor(index: number) {
    const colors = ['#06b6d4', '#f59e0b', '#ef4444', '#4f46e5', '#22c55e'];
    return colors[index % colors.length];
  }
}